KnownServices = require 'db/known-services'
makeErrorEnum = require 'lib/make-error-enum'
PluginRunner = require 'views/internal/plugins/plugin-runner'
Promise = require 'bluebird'
t = require 'teacup'
_ = require 'underscore'
ModelCache = require 'db/model-cache'
parseUrl = require 'url-parse'

FriendlyLinkError = makeErrorEnum 'FriendlyLink', [
  'BoardRequired'
]

template = t.renderable ({ icon, text }) ->
  t.img '.known-service-icon', { src: icon }
  t.text text

module.exports = (el, board) ->
  els = if el.tagName == 'A' then [el] else _.toArray(el.querySelectorAll('a'))

  Promise.map els, (el) ->
    # The URL serializer in HTMLHyperlinkElementUtils.href
    # (https://url.spec.whatwg.org/#concept-url-serializer) appends a slash
    # to the base url e.g. <a href="http://www.trello.com">Trello</a>
    # will return http://www.trello.com/. Unfortunately, this breaks any
    # comparison we make with the link's actual text node if the URL supplied
    # is a base URL with no trailing slash.
    parsedUrl = parseUrl(el.href)
    url = if el.textContent == parsedUrl.origin then parsedUrl.origin else parsedUrl.href

    # If the link already has custom text, leave it alone.
    # In some cases, the href is escaped and the textContent
    # isn't, so also check against the decoded url.
    if el.textContent !in [url, decodeURIComponent(url)]
      return

    Promise.try ->
      if !board
        throw new PluginRunner.Error.NotHandled("no board specified")

      PluginRunner.one
        command: 'format-url'
        board: board
        options:
          url: url
    .catch PluginRunner.Error.NotHandled, ->
      null
    .then (pluginResult) ->
      if pluginResult?.text?
        pluginResult
      else
        KnownServices.interpret(el.href, ModelCache)
    .then (known) ->
      if known?
        el.classList.add 'known-service-link'
        el.innerHTML = template(known)
  .done()



// WEBPACK FOOTER //
// ./app/scripts/views/internal/friendly-links.coffee